import React, { useState, useEffect } from "react";
import "./PinMatch.css";
import Cookies from "js-cookie";

const PinMatch = () => {
  const [generatedPin, setGeneratedPin] = useState("010920");
  const [submittedPin, setSubmittedPin] = useState("");
  const [attempt, setAttempt] = useState(3);
  const [notification, setNotification] = useState("");

  // Generate 6-digit PIN
  const handlePinGenerator = () => {
    const pin = Math.floor(100000 + Math.random() * 900000);
    setGeneratedPin(pin);
    setSubmittedPin("");
    setNotification("");
  };

  const handleButtonPress = (btn) => {
    if (btn === "<") {
      setSubmittedPin((prev) => prev.slice(0, -1));
    } else if (btn === "C") {
      setSubmittedPin("");
    } else {
      if (submittedPin.length < 6) {
        setSubmittedPin((prev) => prev + btn);
      }
    }
  };

  const encode = (str) => btoa(unescape(encodeURIComponent(str)));

  const handleSubmit = () => {
    if (!generatedPin || submittedPin.length !== 6) return;

    const newAttempt = attempt - 1;
    setAttempt(newAttempt);

    if (parseInt(submittedPin) !== parseInt(generatedPin)) {
      if (newAttempt <= 0) {
        Cookies.set("blockuser", "sure", { expires: 1 });
        localStorage.setItem("removeUser", "yes");
      }

      setNotification("notmatched");
      setSubmittedPin("");
    } else {
      setNotification("matched");

      const thisValue = encode("IAmMjAccessUserFind");
      localStorage.setItem("yesIAmFind", thisValue);

      setTimeout(() => {
        window.location.reload();
      }, 1200);
    }

    setTimeout(() => setNotification(""), 2500);
  };

  const accessToPanel = Cookies.get("blockuser");
  const accessToPanelLocal = localStorage.getItem("removeUser");

  return (
    <>
      {accessToPanel === "sure" || accessToPanelLocal === "yes" ? (
        <div className="blocked">🚫 You have been permanently blocked</div>
      ) : (
        <div className="pin-wrapper">
          <div className="card-login">
            <h1>🔐 Secure PIN Access</h1>

            {/* <button className="gen-btn" onClick={handlePinGenerator}>
              Generate 6-Digit PIN
            </button> */}

            <input
              className="pin-display"
              value={submittedPin}
              placeholder="Enter 6-digit PIN"
              disabled
            />

            <div className="msg">
              {notification === "notmatched" && (
                <span className="error">❌ Wrong PIN</span>
              )}
              {notification === "matched" && (
                <span className="success">✅ Access Granted</span>
              )}
            </div>

            <div className="keypad">
              {["1", "2", "3", "4", "5", "6", "7", "8", "9", "<", "0", "C"].map(
                (k) => (
                  <button
                    key={k}
                    className="key"
                    onClick={() => handleButtonPress(k)}
                  >
                    {k}
                  </button>
                ),
              )}
            </div>

            <button
              className="submit"
              onClick={handleSubmit}
              disabled={attempt <= 0}
            >
              Submit
            </button>

            <p className="attempts">Attempts left: {attempt}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default PinMatch;
